export const filterConfig = {
  location: {
    title: 'Локация',
    options: [],
    searchPlaceholder: 'Найти локацию',
  },
  typeActivity: {
    title: 'Тип деятельности',
    options: [],
    searchPlaceholder: 'Найти тип деятельности',
  },
  typeDocument: {
    title: 'Тип документа',
    options: [],
    searchPlaceholder: 'Найти тип документа',
  },
  responsible: {
    title: 'Ответственный',
    searchPlaceholder: '',
    hasSearch: false,
  },
  created: {
    title: 'Дата начала действия',
    hasSearch: false,
  },

  dataTable: {
    title: 'Дата окончания действия',
    hasSearch: false,
  },
  statusLicanse: {
    title: 'Статус документа',
    options: [],
    hasSearch: false,
  },
  status: {
    title: 'Статус действий',
    options: [],
    hasSearch: false,
  },
};

export const initialFilter = {
  location: { selected: [], selectedIds: [], search: '' },
  typeActivity: { selected: [], selectedIds: [], search: '' },
  typeDocument: { selected: [], selectedIds: [], search: '' },
  responsible: { selected: [], selectedIds: [], search: '' },
  created: { startDate: '', endDate: '' },
  dataTable: { startDate: '', endDate: '' },
  statusLicanse: { selected: ['В процессе', 'Действующий', 'Просрочен'], selectedIds: [1, 2, 3] },
  status: { selected: [], selectedIds: [] },
};

export const initialFilterOpen = {
  location: false,
  typeActivity: false,
  typeDocument: false,
  responsible: false,
  created: false,
  dataTable: false,
  statusLicanse: false,
  status: false,
};
